module.exports = __webpack_public_path__ + "img/equip-middle.7e19f3a7.png";